import React, { useState, useEffect } from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useParams } from 'react-router-dom';
import DataPoller from 'components/ui/DataPoller';
import CustomerActionCreators from 'actions/CustomersActionCreators';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';
import Spinner from 'components/ui/Spinner';
import _ from 'underscore';
import CargomaticCard from 'components/v2/card';
import CarrierDriverWebAPIUtils from 'utils/CarrierDriverWebAPIUtils';
import CustomerStore from 'stores/CustomerSearchStore';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import CommentList from 'components/modules/comments/CommentList';
import { useTranslation } from 'react-i18next';
import Sidebar from '../../carrier/AdminSidebar';
import RecentActivity from '../recent-activity';

const POLLING_FREQ = 10000;

const Loading = function () {
  return (
    <div className="justify-center lg:col-span-1" style={{ top: '50%' }}>
      <div className="align-middle">
        <span className="text-5xl text-green">
          <Spinner showMessage={false} />
        </span>
      </div>
    </div>
  );
};

const ActivitySettings = () => {
  const { t } = useTranslation();
  const [carrier, setCarrier] = useState(null);
  const [audits, setAudits] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();
  const carrierId = params.id;
  const renderSidebar = () => (
    <Sidebar userId={carrierId} activePage="activity" />
  );
  const breadcrumbs = {
    pages: [
      {
        name: carrier?.name || t('CARRIER'),
        href: `/users/${carrierId}`,
        current: false,
      },
      {
        name: 'Activity',
        href: `/users/${carrierId}/carrier-settings/activity`,
        current: true,
      },
    ],
  };

  const onAuditChange = () => {
    const auditsRes = CustomerStore.getCustomerAudits();
    setIsLoading(false);
    if (!_.isEqual(auditsRes, audits)) {
      return setAudits(auditsRes);
    }
  };

  const fetchUser = async () => {
    const user = await getCustomerV2(carrierId);
    setCarrier(user);
  };

  const getUserAudits = () => {
    CustomerActionCreators.fetchCustomerAudits(carrierId, { page });
  };

  const handleAddComment = (message) => {
    CarrierDriverWebAPIUtils.addDriverComment(carrierId, message);
  };

  useEffect(() => {
    fetchUser();
    CustomerStore.addAuditChangeListener(onAuditChange);

    return () => {
      setIsLoading(true);
      CustomerStore.removeAuditChangeListener(onAuditChange);
    };
  }, [page]);

  return (
    <LayoutWithSidebar
      sidebar={renderSidebar}
      breadcrumbs={breadcrumbs}
      className="py-4"
    >
      {carrier ? (
        <>
          <DataPoller action={getUserAudits} frequency={POLLING_FREQ} />
          <div className="mb-6">
            <RecentActivity email={carrier.email} />
          </div>
          <CargomaticCard
            className="mb-6"
            removeHorizontalPadding
            removeVerticalPadding
            header={() => <h3 className="my-0">{t('ACCOUNT_DISCUSSION')}</h3>}
          >
            <CommentList
              comments={carrier.comments}
              onCommentAdd={handleAddComment}
              paginate
            />
          </CargomaticCard>
          <CargomaticCard
            className="mb-6 col-span-1"
            header={() => <h3 className="my-0">{t('AUDIT_HISTORY')}</h3>}
          >
            <AuditHistory
              audits={audits}
              paginate
              onClick={(page) => {
                setPage(page);
              }}
              currentPage={page}
              isLoading={isLoading}
            />
          </CargomaticCard>
        </>
      ) : (
        <Loading />
      )}
    </LayoutWithSidebar>
  );
};

export default ActivitySettings;
